module.exports = __webpack_public_path__ + "static/media/courier_512.801ade83.png";